import Fetch from './Fetch';
import { notification } from 'antd';
import { omitEmpty } from '@/Libs/Helper';
import { cloneDeep } from 'lodash'

const { Cfetch, interceptors } = Fetch;
/**
 * config 自定义配置项
 * @param withoutCheck 不使用默认的接口状态校验，直接返回 response
 * @param returnOrigin 是否返回整个 response 对象，为 false 只返回 response.data
 * @param showError 全局错误时，是否使用统一的报错方式
 * @param canEmpty 传输参数是否可以为空
 * @param mock 是否使用 mock 服务
 * @param timeout 接口请求超时时间，默认10秒
 */
const configDefault = {
  showError: true,
  canEmpty: false,
  returnOrigin: false,
  withoutCheck: false,
  mock: false,
  timeout: 10000,
  responseType: 'json',
  credentials: 'include',
};

// 添加请求拦截器
interceptors.request.use((config) => {
  const current_page = `${window.document.location.pathname}${window.document.location.hash}`;
  const headers = Object.assign(
    { 'Content-Type': 'application/json;charset=utf-8', mode: 'no-cors', __froute: current_page, __u: localStorage.getItem('userId') },
    config.headers
  );
  const configmerge = Object.assign({ ...configDefault }, config, { headers });
  configDefault.responseType = configmerge.responseType;
  return configmerge;
});

// 添加响应拦截器
interceptors.response.use(async (response) => {
  // console.log('拦截器response ==>', response);
  // console.log('configDefault', configDefault);
  // HTTP 状态码 2xx 状态入口，data.code 为 200 表示数据正确，无任何错误
  if ((response.status >= 200 && response.status < 300)) {

    let res;
    try {
      // TODO: 这里是复制一份结果处理，在这里可以做一些操作
      res = await resultReduction(response.clone());
    } catch (error) {
      notification.success({
        message: '操作成功',
      });
      return response;
    }

    if (configDefault.responseType === 'json' && res?.errno !== 0) {
      notification.warn({
        // message: '警告',
        message: res.errmsg,
        description: res.data || '',
      });
    }
    return response;
  } else {
    // 非 2xx 状态入口
    if (configDefault.withoutCheck) {
      // 不进行状态状态检测
      return Promise.reject(response);
    }
    const res2 = response.status !== 500 ? await response?.json() : null;
    const rtxt = response.status !== 401 ? '请联系 技术组' : '';
    notification.error({
      message: res2?.errmsg ?? '服务器返回错误',
      description: `错误码: ${response.status} ${response.statusText}. ${rtxt}`,
    });
    return Promise.reject(response);
  }
});

// 结果处理，fetch请求响应结果是promise，还得处理
async function resultReduction(response) {
  let res = '';
  switch (configDefault.responseType) {
    case 'json':
      res = await response.json();
      break;
    case 'text':
      res = await response.text();
      break;
    case 'blob':
      res = await response.blob();
      break;
    default:
      res = await response.json();
      break;
  }
  // console.log('结果处理', res);
  return res;
}

export function request(method, path, data, config) {
  const _data = omitEmpty(cloneDeep(data || {}));
  const myInit = {
    ...configDefault,
    ...config,
    method,
    body: JSON.stringify(data),
  };
  if (method === 'GET') {
    let params = '';
    let ifp = '';
    if (data) {
      // 对象转url参数
      params = new URLSearchParams(data).toString();
      ifp = params ? '?' : ifp;
    }
    ifp = path.includes('?') ? '' : ifp;
    return Cfetch(`${path}${ifp}${params}`, {
      ...configDefault,
      ...config,
    });
  }

  return Cfetch(path, myInit);
}

// get请求方法使用封装
export function get(path, data, config) {
  return request('GET', path, data, config);
}

// post请求方法使用封装
export function post(path, data, config) {
  return request('POST', path, data, config);
}

// put请求方法使用封装
export function put(path, data, config) {
  return request('PUT', path, data, config);
}

// delete请求方法使用封装
export function del(path, data, config) {
  return request('DELETE', path, data, config);
}

export default {
  fetch: Cfetch,
  get,
  post,
  put,
  delete: del,
};
